import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "userSwitch"
const UserSwitchIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M17.411 18.023 16.345 19.07H21.775V20.686H16.344L17.41 21.732 16.245 22.875 13.19 19.878 16.246 16.88zM10.5 13.125C11.366 13.125 12.148 13.195 12.855 13.32V14.846C12.172 14.706 11.392 14.625 10.5 14.625 6.508 14.625 4.756 16.24 3.911 17.647 3.607 18.154 3.404 18.667 3.267 19.125H11.815L11.047 19.878 11.81 20.625H1.5S1.5 13.125 10.5 13.125M22.94 14.622 19.883 17.62 18.718 16.477 19.784 15.43H14.354V13.814H19.785L18.718 12.768 19.884 11.625z" />
          <path
            fillRule="evenodd"
            d="M10.875 1.5C13.567 1.5 15.75 3.683 15.75 6.375S13.567 11.25 10.875 11.25 6 9.067 6 6.375 8.183 1.5 10.875 1.5M10.875 3C9.011 3 7.5 4.511 7.5 6.375S9.011 9.75 10.875 9.75 14.25 8.239 14.25 6.375 12.739 3 10.875 3"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default UserSwitchIcon
